import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { userFeature } from './state/user/user.feature';
import { organizationFeature } from './state/organization/organization.feature';
import { userSettingsFeature } from './state/user-settings/user-settings.feature';
import { permissionsFeature } from './state/permissions/permissions.feature';
import { connectivityFeature } from './state/connectivity/connectivity.feature';
import * as authEffects from './effects/auth.effects';
import * as userEffects from './effects/user.effects';
import * as settingsEffects from './effects/user-settings.effect';
import * as organizationEffects from './effects/organization.effect';
import * as permissionsEffects from './effects/permissions.effects';
import * as connectivityEffects from './effects/connectivity.effects';
import * as chatEffects from './effects/chat.effects';
import * as sharedEffects from './effects/shared.effects';

// share-chat registers feature modules that require StoreRootModule/EffectsRootModule.
export const provideAppState = (): EnvironmentProviders[] => [
  importProvidersFrom(
    StoreModule.forRoot({}),
    StoreModule.forFeature(userFeature),
    StoreModule.forFeature(organizationFeature),
    StoreModule.forFeature(userSettingsFeature),
    StoreModule.forFeature(permissionsFeature),
    StoreModule.forFeature(connectivityFeature),
    EffectsModule.forRoot(
      authEffects,
      userEffects,
      settingsEffects,
      organizationEffects,
      permissionsEffects,
      connectivityEffects,
      chatEffects,
      sharedEffects,
    ),
  ),
];
